import React from 'react';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import AppButton from "../../ui/AppButton";
import Dialog from "@material-ui/core/Dialog";
import Session from "../../helpers/Session";
import AppToast from "../../ui/AppToast";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppInputNumber from "../../ui/AppInputNumber";

class AssociateAccount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                cuenta: {
                    key: 'cuenta',
                    value: '',
                    required: true
                }
            },
        }
    }

    handleChange = (e) => {
        this.setState({
            form: {
                cuenta: {
                    value: e.target.value
                }
            }
        })
    }

    handleSubmit = async () => {
        const userData = Session.getLogin();

        // Valida que el usuario este logueado
        if (!userData) {
            AppToast('Debe iniciar sesión!', false);
            return;
        }

        // Valida que indique el numero de cuenta
        if (String(this.state.form.cuenta.value).trim() === '') {
            AppToast('Debe ingresar el número de cuenta', false)
            return;
        }

        let params = {
            cuentaCodigo: this.state.form.cuenta.value,
            terceroID: userData.terceroID
        };
        const data = await Api.post(`${Env.UrlSeguridad}/postAddCtaToTercero`, params);

        if (data.cod !== '1') {
            AppToast(data.msg, false);
            return;
        }

        AppToast('La cuenta se vinculó con éxito', true);
        this.resetForm();
    }

    resetForm = () => {
        const userData = Session.getLogin();
        this.props.getCuentas(userData);
        this.props.onClose();
        this.setState({
            form: {
                cuenta: {
                    value: ''
                }
            }
        });
    }

    render() {

        const {open, onClose} = this.props;

        return (
            <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Asociar una cuenta</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Por favor ingrese el número de cuenta.
                    </DialogContentText>

                    <AppInputNumber
                        id={this.state.form.cuenta.key}
                        name={this.state.form.cuenta.key}
                        value={this.state.form.cuenta.value}
                        label='Nro. Cuenta'
                        onChange={this.handleChange}
                        required={true}
                    />

                </DialogContent>
                <DialogActions>

                    <AppButton
                        type='button'
                        label='Cancelar'
                        size='small'
                        onClick={onClose}
                    />

                    <AppButton
                        type='button'
                        label='Guardar'
                        size='small'
                        onClick={this.handleSubmit}
                    />

                </DialogActions>
            </Dialog>
        );
    }
}

export default AssociateAccount